import React from 'react'
import styled from 'styled-components'
import { stringify } from 'qs'
import { serialize } from 'dom-form-serializer'
import ChevronDown from 'react-feather/dist/icons/chevron-down'

import { boxShadow, boxShadowActive, borderRadius } from '../globalStyles'
import { ButtonInput, Container } from './common'
import AlertCard from './AlertCard'
import ScrollToTop from './ScrollToTop'

const fetch = window.fetch

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 500px;
  margin: 0 auto;

  & > * + * {
    margin-top: 1.5rem;
  }
`
const Label = styled.label`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1.4rem;
  margin-bottom: 0.2rem;
  padding-left: 0.2rem;

  &.has-arrow:after {
    content: '';
    position: absolute;
    right: 3px;
    top: 50%;
    border-right: 1px solid;
    border-bottom: 1px solid;
    height: 10px;
    width: 10px;
    transform: translateY(-75%) rotate(45deg);
    pointer-events: none;
  }
`
const Input = styled.input`
  appearance: none;
  font-family: inherit;
  background: white;
  font-weight: 400;
  flex-grow: 1;
  box-sizing: border-box;
  display: block;
  margin: 0;
  border: none;
  border: 1px solid whitesmoke;
  width: 100%;
  padding: 1.25rem;
  line-height: 1;
  transition: border-color 0.2s;
  resize: none;
  transition: box-shadow 0.15s ease;
  border-radius: ${borderRadius};
  box-shadow: ${boxShadow};

  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  &:focus {
    outline: none;
    box-shadow: ${boxShadowActive};
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }

  &::placeholder {
    text-transform: none;
    color: #bababa;
  }
`
const Button = styled(ButtonInput)`
  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }
`
const SelectWrap = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;

  svg {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
`
const SelectInput = Input.withComponent('select').extend`
  cursor: inherit;
  appearance: none;
  margin: 0;
  width: 100%;
  padding: 1.25rem;
  line-height: 1.1;

  &:focus {
    outline: none;
  }
`
const Select = props => (
  <SelectWrap>
    <SelectInput {...props} />
    <ChevronDown />
  </SelectWrap>
)

const Textarea = Input.withComponent('textarea')

class FeedbackForm extends React.Component {
  static defaultProps = {
    name: 'Feedback Form',
    subject: '', // optional subject of the notification email
    action: '',
    successMessage: 'Thanks for your enquiry, we will get back to you soon',
    errorMessage:
      'There is a problem, your message has not been sent, please try contacting us via email'
  }

  state = {
    alert: null,
    disabled: false
  }

  handleSubmit = e => {
    e.preventDefault()
    if (this.state.disabled) return

    const form = e.target
    const data = serialize(form)
    this.setState({ disabled: true })
    fetch(form.action + '?' + stringify(data), {
      method: 'POST'
    })
      .then(res => {
        if (res.ok) {
          return res
        } else {
          throw new Error('Network error')
        }
      })
      .then(() => {
        form.reset()
        this.setState({
          alert: {
            type: 'success',
            message: this.props.successMessage
          },
          disabled: false
        })
      })
      .catch(err => {
        console.error(err)
        this.setState({
          disabled: false,
          alert: {
            message: this.props.errorMessage,
            type: 'error'
          }
        })
      })
  }

  render () {
    const { name, subject, action } = this.props
    const { alert } = this.state
    return (
      <div>
        {alert && [
          <AlertCard
            type={alert.type}
            message={alert.message}
            title={alert.title}
          />,
          <ScrollToTop />
        ]}
        <Container>
          <Form
            className='FeedbackForm'
            name={name}
            action={action}
            onSubmit={this.handleSubmit}
            data-netlify=''
            data-netlify-honeypot='_gotcha'
          >
            <Label htmlFor='name'>Your Name</Label>
            <Input type='text' name='name' />
            <Label htmlFor='email'>Email</Label>
            <Input
              type='email'
              id='email'
              placeholder='name@example.com'
              name='email'
            />
            <Label htmlFor='type'>Feedback Type</Label>
            <Select name='type' id='type' required>
              <option>General</option>
              <option>Technical Issue</option>
              <option>Correction</option>
              <option>Suggestion</option>
              <option>Compliment</option>
            </Select>
            <Label htmlFor='comment'>Comment</Label>
            <Textarea
              name='comment'
              id='comment'
              placeholder='Your comment here'
              rows='10'
              required
            />
            <input type='text' name='_gotcha' style={{ display: 'none' }} />
            {!!subject && (
              <input type='hidden' name='subject' value={subject} />
            )}
            <input type='hidden' name='form-name' value={name} />
            <Button
              isPrimary
              shadow
              type='submit'
              value='Submit'
              disabled={this.state.disabled}
            />
          </Form>
        </Container>
      </div>
    )
  }
}

export default FeedbackForm



// WEBPACK FOOTER //
// ./src/components/FeedbackForm.js